import React, { useState, useEffect, useCallback } from "react";
import { getBgvAgencies } from "../../../services/axios/AuthApis/TeamCollabApis";

const BGVForm = ({ isOpen, onBgvRequiredChange, bgvRequired, localMember, onLocalMemberChange }) => {
    const [agencies, setAgencies] = useState([]);

    const fetchAgencies = useCallback(async () => {
        try {
            const data = await getBgvAgencies();
            setAgencies(data.agencies || []);
        } catch (err) {
            console.error("Error fetching agencies:", err);
        }
    }, []);

    useEffect(() => {
        if (isOpen) {
            fetchAgencies();
        }
    }, [isOpen, fetchAgencies]);

    useEffect(() => {
        if (bgvRequired) {
            fetchAgencies();
        }
    }, [bgvRequired, fetchAgencies]);

    return (
        <>
            <div className="col-span-2 mt-2">
                <label className="flex items-center space-x-2 text-sm font-medium text-gray-700">
                    <input
                        type="checkbox"
                        checked={bgvRequired}
                        onChange={(e) => onBgvRequiredChange(e.target.checked)}
                        className="h-4 w-4 text-blue-600 border-gray-300 rounded"
                    />
                    <span>Background Verification Required</span>
                </label>
            </div>

            {bgvRequired && (
                <div className="col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Select BGV Agency</label>
                    <select
                        value={localMember.bgv_agency || ""}
                        onChange={(e) => onLocalMemberChange({ ...localMember, bgv_agency: e.target.value })}
                        className="w-full border border-gray-300 rounded-md px-3 py-2 focus:ring-blue-500 focus:border-blue-500"
                    >
                        <option value="">Choose agency</option>
                        {agencies?.map((a) => (
                            <option key={a.id} value={a.id}>{a.name}</option>
                        ))}
                    </select>
                </div>
            )}
        </>
    );
};

export default BGVForm;
